import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QnSbnDataService } from '../../../services/qn-sbn-data-service.service';
import { QnSbnService } from '../../../services/qn-sbn-service.service';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'dl-add-note',
  templateUrl: './add-note.component.html',
  styleUrls: ['./add-note.component.scss']
})
export class AddNoteComponent implements OnInit {
  public addNoteFC = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]);
  public internalNote: any;
  public isEditForm: boolean = false;
  constructor(
   @Inject(MAT_DIALOG_DATA) public data: any,
   private _QnSbnDataService: QnSbnDataService,
   private qnsbnservice: QnSbnService,
   public dialogRef: MatDialogRef<AddNoteComponent>,
   private readonly oneSnackBar?: OneSnackBarService
   
  ) { }

  ngOnInit(): void {
    if(this.data?.tableData?.notificationData?.NoteText){
      this.internalNote=this.data.tableData.notificationData.NoteText;
      this.addNoteFC.setValue(this.internalNote);
      this.isEditForm = true;
    }
  }

  public saveNote() {
    let noteData = {};
    let responseMessage = '';
    let noteText = this.addNoteFC.value;
    if(noteText.length > 500){
      this.oneSnackBar.open("Note is too long. Maximum length is 500 characters.", OneSnackBarType.ERROR, '', { duration: 5000 });
    }else{
      noteData = {
      "NoteType": "Notification",
      "NoteText" : this.addNoteFC.value,
      "NotificationId": this.data.tableData.notificationData.NotificationId || "",
      "userId": this.data.tableData.notificationData.UserId || "",
      "userRole":this.data.tableData.notificationData.UserRole || ""
      }
      if(this.isEditForm){
        responseMessage = "Note updated successfully";
      }else{
        responseMessage = "Note added successfully";
      }
     let newNote = this.addNoteFC.value;
      this.qnsbnservice.saveInternalNote(noteData).subscribe(
        (responseData: any)=> {
          if(responseData.$metadata?.httpStatusCode === 200){
            this.oneSnackBar.open(responseMessage, OneSnackBarType.SUCCESS, '', { duration: 5000 });
            this.data.tableData.notificationData.NoteText = this.addNoteFC.value;
            this.dialogRef.close({ data: responseData, rowIndex: this.data.rowIndex, newNote });
          }
        },
         (error: HttpErrorResponse) => {
          console.log("error", error)
                this.qnsbnservice.httpErrorHandler(error, 'Could not save Note.');
                 this.oneSnackBar.open(error.error, OneSnackBarType.ERROR, '', { duration: 5000 });
          }
      )
    }
  }

}
